<template>
    <picture class="ds-image-element">
        <source :media="`(max-width: ${$options.SCREEN_BREAKPOINT_MEDIUM - 1}px)`" :srcset="image.small.src"/>
        <source :media="`(max-width: ${$options.SCREEN_BREAKPOINT_LARGE - 1}px)`" :srcset="image.medium.src"/>
        <source :media="`(min-width: ${$options.SCREEN_BREAKPOINT_LARGE}px)`" :srcset="image.large.src"/>
        <img
            class="ds-image-element__image"
            :class="{ 'ds-image-element__image--border-radius': withBorderRadius }"
            :src="image.small.src"
            :alt="image.small.name" />
    </picture>
</template>

<script>
import { SCREEN_BREAKPOINT_MEDIUM, SCREEN_BREAKPOINT_LARGE } from '../../foundation/tokens/exported-variables.js';

export default {
    name: 'DsImageElement',
    props: {
        /**
         * Image
         * @property {Object} image.small - { src: String, name: String }
         * @property {Object} image.medium - { src: String, name: String }
         * @property {Object} image.large - { src: String, name: String }
         */
        image: {
            type: Object,
            required: true,
            validator: obj => ['small', 'medium', 'large'].every(
                key => key in obj && ['src', 'name'].every(
                    innerKey => innerKey in obj[key]
                )
            )
        },
        /**
         * with-border-radius prop, sets a border radius of 6px to the image if set to true
         */
        withBorderRadius: {
            type: Boolean,
            default: false
        }
    },
    created () {
        // scss variables for screen breakpoints in exported-variables
        this.$options.SCREEN_BREAKPOINT_MEDIUM = SCREEN_BREAKPOINT_MEDIUM;
        this.$options.SCREEN_BREAKPOINT_LARGE = SCREEN_BREAKPOINT_LARGE;
    }
};
</script>

<style lang="scss" scoped>
@import '../../foundation/tokens/variables';

.ds-image-element {
    display: flex; // removes white space from the bottom

    &__image {
        height: auto;
        width: 100%;

        &--border-radius {
            border-radius: $spacing-6;
        }
    }
}
</style>
